import {combineReducers} from "redux";

import dimissionViewModel from "./dimissionViewModel";
import dimissionDetailViewModel from "./dimissionDetailViewModel";
import inServiceViewModel from "./inServiceViewModel";
import inServiceDetailViewModel from "./inServiceDetailViewModel";
import qualityControlViewModel from "./qualityControlViewModel";
import qualityControlStatTableViewModel
from "./qualityControlStatTableViewModel";
import staffDistViewModel from "./staffDistViewModel";
import clothesViewModel from "./clothesViewModel";
import multiWorkViewModel from "./multiWorkViewModel";

const rootViewModel = combineReducers({
    dimissionViewModel,
    dimissionDetailViewModel,
    inServiceViewModel,
    inServiceDetailViewModel,
    qualityControlViewModel,
    qualityControlStatTableViewModel,
    staffDistViewModel,
    clothesViewModel,
    multiWorkViewModel,
});

export default rootViewModel;
